import Big from 'big.js';
import { OrderDirection } from '@block-explorer/ui';
import { ValidatorWithInfo } from '@block-explorer/entities';

export const compareBigNumbers = (a: string, b: string): number => {
  if (Big(a).eq(b)) {
    return 0;
  } else {
    return Big(a).lt(b) ? 1 : -1;
  }
};

export const compareBooleans = (a?: boolean, b?: boolean): number => {
  return a === b ? 0 : a ? -1 : 1;
};

export const compareValidatorsByPriority = (
  a: ValidatorWithInfo,
  b: ValidatorWithInfo,
  orderPriorityKey: string,
  defaultSortKey: string
) =>
  compareBooleans(a[orderPriorityKey], b[orderPriorityKey]) ||
  compareBigNumbers(a[defaultSortKey], b[defaultSortKey]);

export const sortDates = (dateA: Date, dateB: Date) =>
  dateB.getTime() - dateA.getTime();

export const sortNumericFields = (
  sortedNumberA: number | string, // The project convention is to pass big numbers as strings
  sortedNumberB: number | string,
  orderDirection: OrderDirection | undefined
): number => {
  if (sortedNumberA === undefined || sortedNumberB === undefined) {
    return 0;
  }

  if (typeof sortedNumberA === 'number' && typeof sortedNumberB === 'number') {
    return orderDirection === OrderDirection.ASC
      ? sortedNumberA - sortedNumberB
      : sortedNumberB - sortedNumberA;
  }
  if (orderDirection === OrderDirection.ASC) {
    return compareBigNumbers(
      sortedNumberB.toString(),
      sortedNumberA.toString()
    );
  }
  return compareBigNumbers(sortedNumberA.toString(), sortedNumberB.toString());
};
